const SubTitle = (props) => {
  const { children } = props;
  return <h4>{children}</h4>;
};

export default SubTitle;
